import { inject, observer } from 'mobx-react';
import React from 'react'
import ModalWrapper from '../Inputs/ModalWrapper';
import { ReactComponent as CloseIcon } from "../../svg/close.svg";

@inject('store', 'workAreaStore') @observer
class AdminModal extends React.Component {

  constructor(props){
    super(props)
    this.state = {
      //title: '',
      inputs: {
        tags: [],
        description: ''
      },
      dropDowns: {
        status: [
          {
            value: 'draft',
            selected: true,
          },
          {
            value: 'review',
            selected: false,
          },
          {
            value: 'active',
            selected: false,
          },
          {
            value: 'unlisted',
            selected: false,
          }
        ]
      },
      hideStatus: false,
      checkBox: {
        name: 'freeTemplate',
        value: false
      },
      featuredCheckbox: {
        name: 'Featured checkbox',
        value: false
      }
    }
  }

  toggle(){
    this.props.store.toggleAnyModal('adminModalOpen', !this.props.store.modals.adminModalOpen)
  }

  async removeOptions(){
    const status = [{
      value: 'draft',
      selected: true,
    },
    {
      value: 'review',
      selected: false,
    }]
    this.setState({
      dropDowns: {
        ...this.state.dropDowns,
        status
      }
    })
    return true
  }

  async componentDidMount(){
    if(this.props.store.categoryList.length === 0){
      await this.props.store.getCategories()
    }
    if(this.props.store.role.level !== 99){
      await this.removeOptions()
    }
    const { workAreaStore } = this.props
    const copy = {
      ...this.state.inputs
    }
    if(!workAreaStore.publicDesignProps.tags){
      copy.tags = []
    }else{
      copy.tags = workAreaStore.publicDesignProps.tags
    }
    copy.description = workAreaStore.publicDesignProps.description
    const dropDowns = {
      ...this.state.dropDowns
    }
    const checkBox = {
      ...this.state.checkBox
    }
    const featuredCheckbox = {
      ...this.state.featuredCheckbox
    }
    checkBox.value = workAreaStore.publicDesignProps.freeTemplate
    featuredCheckbox.value = workAreaStore.publicDesignProps.featured
    dropDowns.status.forEach((obj, idx) => {
      if(obj.value === workAreaStore.publicDesignProps.status){
        dropDowns.status[idx].selected = true
      }else{
        dropDowns.status[idx].selected = false
      }
    })
    let hideStatus = false
    const s = workAreaStore.publicDesignProps.status
    if((s === 'active' || s === 'unlisted') && this.props.store.role.level !== 99){
      hideStatus = true
    }
    this.props.store.categoryList.forEach((obj, idx) => {
      if(obj.value === workAreaStore.publicDesignProps.category){
        this.props.store.editSelectedCategoryValue(obj.value, true)
      }
    })
    this.setState({ dropDowns, inputs: copy, checkBox, featuredCheckbox, hideStatus })
  }

  handleTitleChange(e){
    return
  }

  handleChange(e, dropdown = false, checkbox = false, featuredCheckbox = false){
    const { name, value } = e.target
    if(checkbox || featuredCheckbox){
      const copy = checkbox ? {...this.state.checkBox} : {...this.state.featuredCheckbox}
      const v = !copy.value
      copy.value = v
      let stateName = 'checkBox'
      if(featuredCheckbox){
        stateName = 'featuredCheckbox'
      }
      this.setState({
        [stateName]: copy
      })
      this.props.workAreaStore.updateDesignPublicProp(name, v)
      return
    }
    if(dropdown){
      if(name === 'category'){
        this.props.store.editSelectedCategoryValue(value, true)
      }else{
        const copy = { ...this.state.dropDowns }
        copy[name].forEach((key, idx) => {
          if(key.value === value){
            copy[name][idx].selected = true
          }else{
            copy[name][idx].selected = false
          }
        })
        this.setState({
          dropDowns: copy
        }) 
      }
      this.props.workAreaStore.updateDesignPublicProp(name, value)
    }else{
      let val = value
      if(name === 'tags'){
        val = value.split(', ')
      }
      const inputCopy = {...this.state.inputs}
      inputCopy[name] = val
      this.setState({ inputs: inputCopy })
      this.props.workAreaStore.updateDesignPublicProp(name, val)
    }
  }

  async handleSave(){
    await this.props.workAreaStore.updatePublicProps()
  }

  render(){
    const { inputs, dropDowns, checkBox, hideStatus, featuredCheckbox } = this.state
    const { propsLoading, compiled } = this.props.workAreaStore
    const { categoryList } = this.props.store
    const selectedCategory = this.props.store.getSelectedCategory()
    if(!compiled){
      return <div />
    }
    return (
      <ModalWrapper
        close={this.toggle.bind(this)}
        modalClass={'admin-modal'}
      >
        <React.Fragment>
          <div className='modal-header'>
            <h5 className='modal-title'>
              Edit Public Design
              <CloseIcon className='close-icon cursor-pointer' style={{
                position: 'absolute',
                right: '20px',
                top: '20px'
              }} onClick={this.toggle.bind(this)} />
            </h5>
          </div>
          <div className='modal-body'>
            <div className='row no-gutters'>
            {
              Object.keys(inputs).map((key, idx) => {
                return (
                  <div key={key + idx} className='col-12'>
                    <div className='form-group'>
                      <label className='label gray'>{key}</label>
                      {
                        key === 'tags' ? 
                        (
                          <textarea
                            style={{
                              height: '150px',
                              resize: 'none'
                            }} 
                            type='text' 
                            name={key}
                            className='form-control' 
                            value={inputs[key].join(', ')} 
                            onChange={e => this.handleChange(e)}
                          />
                        )
                        :
                        (
                          <textarea 
                            style={{
                              height: '150px',
                              resize: 'none'
                            }}
                            type='text' 
                            name={key}
                            className='form-control' 
                            value={inputs[key]} 
                            onChange={e => this.handleChange(e)}
                          />
                        )
                      }
                    </div>
                  </div>
                )
              })
            }
            {
              Object.keys(dropDowns).map(key => {
                const val = dropDowns[key].find(({ selected }) => selected)
                if(key === 'status' && hideStatus){
                  return <div />
                }
                return (
                  <div key={key} className='col-12'>
                    <div className='form-group'>
                      <label className='label gray'>{key}</label>
                      <select
                        style={{textTransform: 'capitalize'}}
                        className='form-control'
                        type='select'
                        key={key}
                        name={key}
                        value={val ? val.value : ''}
                        onChange={e => this.handleChange(e, true)}
                      >
                        {
                          dropDowns[key].map((option, optIdx) => (
                            <option key={option.value + optIdx} selected={option.selected} value={option.value}>{option.label || option.value}</option>
                          ))
                        }
                      </select>
                    </div>
                  </div>
                )
              })
            }
            <div className='col-12'>
              <div className='form-group'>
                <label className='label gray'>Category</label>
                <select
                  style={{ textTransform: 'capitalize' }}
                  className='form-control'
                  type='select'
                  name='category'
                  value={selectedCategory ? selectedCategory.value : ''}
                  onChange={e => this.handleChange(e, true)}
                >
                  {
                    categoryList.map((option, optIdx) => (
                      <option key={option.value + optIdx} selected={option.selected} value={option.value}>{option.label || option.value}</option>
                    ))
                  }
                </select>
              </div>
            </div>
            <div className='col-12'>
              <div className='form-group'>
                <label className='label gray'>
                  Free template
                </label>
                <input
                  type='checkbox'
                  checked={checkBox.value}
                  className='form-control paid-check'
                  name='freeTemplate'
                  onClick={e => this.handleChange(e, false, true)}
                />
              </div>
            </div>
            <div className='col-12'>
              <div className='form-group'>
                <label className='label gray'>
                  Featured template
                </label>
                <input
                  type='checkbox'
                  checked={featuredCheckbox.value}
                  className='form-control paid-check'
                  name='featured'
                  onClick={e => this.handleChange(e, false, false, true)}
                />
              </div>
            </div>
            <div className='col-12 mt-2 d-flex' style={{ justifyContent: 'flex-end' }}>
              {
                propsLoading ? (
                  <span>Saving..</span>
                )
                :
                (
                  <button 
                    className='btn btn-primary'
                    onClick={() => this.handleSave()}
                  >
                    Save
                  </button>
                )
              }
            </div>
            </div>
          </div>
        </React.Fragment>
      </ModalWrapper>
    )
  }

}

export default AdminModal